"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _BalanceItemComponent = _interopRequireDefault(require("./BalanceItemComponent"));
var _Spinner = _interopRequireDefault(require("../common/Spinner/Spinner"));
require("./BalancesListComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var productBalancesClasses = (0, _cssClassesHelper.getBEMClasses)('product-balances');
var BalancesListComponent = function BalancesListComponent(props) {
  var items = props.balances.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_BalanceItemComponent["default"], {
      key: item.ProductId,
      balance: item
    });
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.fetching ? /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null) : /*#__PURE__*/_react["default"].createElement("div", {
    className: productBalancesClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: productBalancesClasses('wrapper')
  }, items)));
};
var _default = exports["default"] = BalancesListComponent;